import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';

export interface AppOptionContext {
  $implicit: any;
  selected: boolean;
}

@Component({
  selector: 'app-option',
  standalone: true,
  imports: [CommonModule],
  styleUrls: ['./option.component.scss'],
  host: { class: 'app-option' },
  template: `
    <ng-container *ngIf="template; else plain">
      <ng-container *ngTemplateOutlet="template; context: templateContext"></ng-container>
    </ng-container>
    <ng-template #plain><ng-content></ng-content></ng-template>
  `,
})
export class OptionComponent {
  @Input() value: any;
  @Input() label?: string;

  @Output() optionClick = new EventEmitter<OptionComponent>();

  @ContentChild(TemplateRef, { static: true }) template?: TemplateRef<AppOptionContext>;

  @HostBinding('class.app-option--selected') isSelected = false;

  constructor(public el: ElementRef) {}

  get labelText(): string {
    return this.label ?? this.el.nativeElement.textContent?.trim() ?? String(this.value ?? '');
  }

  get templateContext(): AppOptionContext {
    return { $implicit: this.value, selected: this.isSelected };
  }

  @HostListener('click')
  onClick() {
    this.optionClick.emit(this);
  }
}
